// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#share-ticket-v2 .summary-clients {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 5px;
  overflow-x: scroll;
  gap: 4px;
  white-space: nowrap;
  width: 100%;
  max-width: 100%;
  padding-left: 5px;
  padding-right: 5px;
}

.summary-clients article {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0px;
  box-sizing: border-box;
  flex-shrink: 0;
  width: -moz-fit-content;
  width: fit-content;
}

.not-selected {
  padding: 5px;
  height: 40px;
  border: 1px solid var(--light-blue);
  border-radius: 4px;
  border-top: 0px;
  border-bottom: 0px;
  opacity: 0.6;
  cursor: pointer;
}
.selected {
  padding-bottom: 0px;
  border-bottom: 2px solid var(--light-blue);
}

.assign-items-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 5px;
  flex-wrap: wrap;
  width: 100%;
  padding: 5px;
}
.summary-clients article strong {
  font-weight: 700;
  font-size: 15px;
  font-family: var(--font);
  color: var(--white-blue);
}
.summary-clients article span {
  font-weight: 600;
  font-size: 15px;
  font-family: var(--font);
  color: var(--white-blue);
}
`, "",{"version":3,"sources":["webpack://./src/components/ClientsSumary/ClientsSummary.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,cAAc;EACd,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,wBAAwB;AAC1B","sourcesContent":["@import url('/src/App.css');\n\n#share-ticket-v2 .summary-clients {\n  display: flex;\n  flex-wrap: nowrap;\n  padding-bottom: 5px;\n  overflow-x: scroll;\n  gap: 4px;\n  white-space: nowrap;\n  width: 100%;\n  max-width: 100%;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.summary-clients article {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 0px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  width: fit-content;\n}\n\n.not-selected {\n  padding: 5px;\n  height: 40px;\n  border: 1px solid var(--light-blue);\n  border-radius: 4px;\n  border-top: 0px;\n  border-bottom: 0px;\n  opacity: 0.6;\n  cursor: pointer;\n}\n.selected {\n  padding-bottom: 0px;\n  border-bottom: 2px solid var(--light-blue);\n}\n\n.assign-items-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 5px;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 5px;\n}\n.summary-clients article strong {\n  font-weight: 700;\n  font-size: 15px;\n  font-family: var(--font);\n  color: var(--white-blue);\n}\n.summary-clients article span {\n  font-weight: 600;\n  font-size: 15px;\n  font-family: var(--font);\n  color: var(--white-blue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
